import { ibhApiService } from '@hub/bearing-hub/common/api-service';
import type {
  IbhBearingPartsIcnParams,
  IbhIcnPartsRequestDto,
  IbhIcnPartsResponseDto,
} from '@igus/iglidur-bearing-hub-api/src/data-contracts';
import * as Sentry from '@sentry/nextjs';

export const fetchIcnParts = async (
  query: IbhBearingPartsIcnParams,
  data: IbhIcnPartsRequestDto
): Promise<IbhIcnPartsResponseDto[]> => {
  try {
    ibhApiService.abortRequest('bearingPartsIcn');
    const response = await ibhApiService.bearingPartsIcn(query, data, { cancelToken: 'bearingPartsLight' });

    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    throw new Error(`Cannot fetch parts for given data: ${JSON.stringify(data)}`);
  }
};
